@solidale.controller 'LocAddCtrl', ['$rootScope', '$scope', '$q', '$location', 'Upload', '$mdDialog', 'uiGmapGoogleMapApi', '$anchorScroll', '$timeout', 'Location', 'Room', ($rootScope, $scope, $q, $location, Upload, $mdDialog, uiGmapGoogleMapApi, $anchorScroll, $timeout, Location, Room) ->

	$iniParams = () ->
		$scope.location = 
			location_id: ''
			name: ''
			desc: ''
			address: ''
			lat: ''
			lng: ''
			room: ''
			structure: ''
			built: ''
			instruments: ''
			traffic: ''
			rooms: []
			user_id: ''

		$scope.files = []

	$iniParams()	
	# ========================	
	# file upload window 
	# =========================
	$scope.openPhotoWindow = ($index=null, $roomphoto=[]) ->
		$mdDialog.show(
			controller: 'ImageUploadWindowCtrl'
			clickOutsideToClose: true
			templateUrl: 'views/window/imageuploadwindow.html'
			locals:
				targetRoomphoto: $roomphoto
				
		).then (data)->
			
			if data.operation == 'add'
				$addRoomphoto(data.roomphoto)
			else if data.operation == 'del'
				$deleRoomphoto($index)
			else
				console.log 'done'

		, (err) ->
	    	console.log 'cancel upload'

	$addRoomphoto = ($roomphoto) ->
		$scope.files.push $roomphoto

	$deleRoomphoto = ($index) ->
		$scope.files.splice($index, 1)

	

	# =========================		 
	# Create Roomc window
	# =========================
	$scope.openRoomWindow = ($index=null, $room=[]) ->
		$mdDialog.show(
			controller: 'RoomAddWindowCtrl'
			clickOutsideToClose: true
			templateUrl: 'views/window/roomaddwindow.html'
			locals:
				targetRoom: $room
				
		).then (data)->
			if data.operation == 'add'
				$addRoom(data.room)
			else if data.operation == 'del'
				$deleRoom($index)
			else
				console.log 'done'

		, (err) ->
	    	console.log 'operation failed'


	$addRoom = ($room) ->
		$scope.location.rooms.push $room

	$deleRoom = ($index) ->
		$scope.location.rooms.splice($index, 1)

	
	# ===================
	# Handling side menu & scrolling
	# ===================
	$tblk_wrapper = document.getElementById("tblkWrapper")
	$wrapper_yoffset = $tblk_wrapper.getBoundingClientRect().top
	$tblk_elements = document.querySelectorAll(".tblk")

	$scope.tblkFocus = 0


	# Page scroll event
	angular.element(tblkWrapper).bind "scroll", () ->
		$curr_scroll = this.scrollTop
		
		for ele, index in $tblk_elements
			$ele_pos = ele.getBoundingClientRect().top - $wrapper_yoffset

			if ($ele_pos > -5 && $ele_pos < 20)
				$scope.tblkFocus = index
				$scope.$apply() # native DOM funcs, need to watch for update


	# Sidemenu click event
	$scope.textBlockScroll = ($index) ->
		$scope.tblkFocus = $index

		$name = $tblk_elements[$index].id
		$location.hash($name)
		$anchorScroll()



	# ===============================
	# GMap
	# ===============================		 
	# g map --------------------
	uiGmapGoogleMapApi.then (maps) ->
		$scope.map = 
			center:
				latitude: 35.0060799
				longitude: 135.7259288
			zoom: 14
			options:
				scrollwheel: false
				mapTypeControl: false

		# location marker		
		$scope.locmarker = 
			id: 1
			coords:
				latitude: 0
				longitude: 0
			options:
				zIndex: 10


		# location search box
		$scope.locationError = false
		$scope.location.name = ''

		$scope.searchbox = 
			parentdiv: 'location-wrapper'
			template: 'views/locAddress.html'
			events: 
				places_changed: (searchBox) ->
					# bug of ng-gmap
					$scope.location.address = $('#address').val()

					place = searchBox.getPlaces()
					if Object.keys(place).length > 0
						$scope.locationError = false

						# $scope.location.address = place[0].formatted_address
						$scope.location.lat = place[0].geometry.location.lat()
						$scope.location.lng = place[0].geometry.location.lng()

						$scope.locmarker = 
							id: 1
							coords:
								latitude: place[0].geometry.location.lat()
								longitude: place[0].geometry.location.lng()
							options:
								zIndex: 10

						$scope.map = 
							center:
								latitude: place[0].geometry.location.lat()
								longitude: place[0].geometry.location.lng()
					else
						$scope.locationError = true
						$scope.location.address = ''

	
	# ===================	
	# Send it!
	# ===================
	$scope.locationInputError = false
	locationCreateError = 0

	$scope.locationCreate = () ->
		$rootScope.openLoading()

		$scope.location.user_id = $rootScope.user.uid
		$scope.location.location_id = Math.random().toString(36).substr(2, 10)

		$checkLocationInput().then (isError)->
			$scope.locationInputError = isError

			if $scope.locationInputError
				$rootScope.closeLoading()

				# Reset error
				$timeout ()-> 
					$scope.locationInputError = false
				, 6000
			else
				$createLocation().then (succ1)->
					if succ1
						console.log 'loc done'

						$createRoom(0).then (succ2) ->

							if succ2
								console.log 'room done'

								$scope.uploadFiles(0).then (succ3)->

									if succ3
										console.log 'photo done'

										$iniParams()
										$rootScope.closeLoading()
										$rootScope.completePrompt('物件をアプロドしました')

									else
										console.log 'photo failed'
										$rootScope.closeLoading()
										$scope.locationCreateError = 3

							else
								console.log 'room failed'
								$rootScope.closeLoading()
								$scope.locationCreateError = 2

					else
						console.log 'loc failed'
						$rootScope.closeLoading()
						$scope.locationCreateError = 1

	

	$checkLocationInput = ()->	
		defer = $q.defer()

		$isError = false

		if $scope.location.rooms.length < 1 || $scope.files.length < 1
			$isError = true
		else
			angular.forEach $scope.location, (v, k) ->
				if v.length < 1
					$isError = true

		
		defer.resolve $isError
		defer.promise

	# 1. Create Location obj
	$createLocation = () ->
		
		Location.new($scope.location).then (resp)->
			$done = true

		, ()->
			$done = false

		
	# 2. Create Room obj
	$createRoom = ($current_room_index) ->
		room = $scope.location.rooms[$current_room_index]
		room.location_id = $scope.location.location_id

		Room.new(room).then (resp)->
			
			if $current_room_index == $scope.location.rooms.length-1
				true
			else
				$current_room_index += 1
				$createRoom($current_room_index)

		, ()->
			false



	# 3. Upload room photos
	$scope.uploadFiles = ($current_photo_index) ->
		roomphoto = $scope.files[$current_photo_index]

		Upload.upload({
			url: '/roomphotos'
			data: 
				file: roomphoto.file
				location_id: $scope.location.location_id
				desc: roomphoto.desc

		}).then (succ) ->
			if $current_photo_index < $scope.files.length-1
				$current_photo_index += 1
				$scope.uploadFiles($current_photo_index)
			else
				true
				
		, (error) ->
			false


	
]